export default "__VITE_ASSET__0ksA28no__"